import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketFinancePaymentSelectionTemplate from './BasketFinancePaymentSelectionTemplate';
import { rem } from 'polished';

export const BasketSelectSectionStyled = styled(BasketFinancePaymentSelectionTemplate)`
    .section {
        cursor: pointer;
        width: 100%;
        border: 1px solid ${({ theme }) => theme.colors.grey25};
        margin-top: ${rem(30)};
        background: none;
        display: flex;
        flex-direction: column;
        text-align: left;
        padding: 0;

        &:hover,
        &:focus-visible,
        &.selected {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            background: ${({ theme }) => theme.colors.primaryLight};

            .inner {
                border: 1px solid ${({ theme }) => theme.colors.primary};
            }
        }

        .inner {
            width: 100%;
            height: 100%;
            padding: ${rem(16)} ${rem(26)} ${rem(15)} ${rem(60)};
            border: 1px solid transparent;
        }

        @media (min-width: ${breakpoints.xs}px) {
            .inner {
                padding: ${rem(26)} ${rem(26)} ${rem(15)} ${rem(64)};
            }
        }

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: block;
            padding-bottom: ${rem(3)};
            position: relative;

            .icon {
                border: 1px solid #73767a;
                width: ${rem(24)};
                height: ${rem(24)};
                position: absolute;
                left: -${rem(40)};
                top: -${rem(2)};
                border-radius: 50%;

                .selected {
                    background: ${({ theme }) => theme.colors.primary};
                    width: ${rem(12)};
                    height: ${rem(12)};
                    position: absolute;
                    top: ${rem(5)};
                    left: ${rem(5)};
                    border-radius: 50%;
                }
            }
        }

        .description {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            line-height: ${rem(22)};
        }

        .summary {
            .totalPrice {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                padding: ${rem(20)} 0 0 0;
                display: flex;

                .infoIcon {
                    width: ${rem(16)};
                    height: ${rem(16)};
                    margin-left: ${rem(10)};

                    svg {
                        g {
                            circle,
                            line {
                                stroke: ${({ theme }) => theme.colors.primary};
                            }
                        }
                    }
                }
            }

            .totalLabel {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                padding: ${rem(5)} 0 ${rem(5)} 0;
                display: block;
            }

            .otherPrices {
                display: flex;
                flex-direction: column;
                gap: ${rem(10)};
                padding: ${rem(15)} 0;
                border-top: 1px solid ${({ theme }) => theme.colors.grey25};
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};

                .otherPrice {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    &.withOrder {
                        order: -1;
                    }
                }

                @media (min-width: ${breakpoints.md}px) {
                    flex-direction: row;
                    flex-wrap: wrap;

                    .otherPrice {
                        width: 49%;
                        margin: ${rem(4)} 0;

                        strong,
                        .formatMoney {
                            white-space: nowrap;
                        }

                        &:nth-child(2n) {
                            padding-left: ${rem(25)};
                        }

                        &.withOrder {
                            order: unset;
                        }
                    }
                }
            }

            .legalText {
                font-size: ${({ theme }) => theme.fontSizes.textTiny};
                color: ${({ theme }) => theme.colors.grey16};
            }
        }
    }
`;
